import React from 'react';
import {
    getTicketPriorityLabel,
    getTicketStatusLabel,
} from '../../../../../helpers/ticket-label-helper';

const statusClassMap = {
    NEW: 'bg-soft-primary text-primary',
    OPEN: 'bg-soft-info text-info',
    IN_PROGRESS: 'bg-soft-warning text-warning',
    PENDING_CUSTOMER: 'bg-soft-warning text-warning',
    PENDING_THIRD_PARTY: 'bg-soft-warning text-warning',
    RESOLVED: 'bg-soft-success text-success',
    CLOSED: 'bg-soft-success text-success',
    CANCELLED: 'bg-soft-danger text-danger',
};

const priorityClassMap = {
    LOW: 'bg-soft-secondary text-secondary',
    MEDIUM: 'bg-soft-info text-info',
    HIGH: 'bg-soft-warning text-warning',
    URGENT: 'bg-soft-danger text-danger',
    CRITICAL: 'bg-danger text-white',
};

export const SearchResultTicket = ({ item, onSelect }) => {
    return (
        <button
            type="button"
            className="search-result-row"
            onClick={() => onSelect?.(item)}
        >
            <div className="d-flex align-items-start justify-content-between gap-3 w-100">
                <div className="min-w-0">
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                        <span className="badge bg-soft-dark text-dark">{item?.code || 'Ticket'}</span>
                        <span className={`badge ${statusClassMap[String(item?.status || '').toUpperCase()] || 'bg-soft-secondary text-secondary'}`}>
                            {getTicketStatusLabel(item?.status)}
                        </span>
                        <span className={`badge ${priorityClassMap[String(item?.priority || '').toUpperCase()] || 'bg-soft-secondary text-secondary'}`}>
                            {getTicketPriorityLabel(item?.priority)}
                        </span>
                    </div>
                    <div className="search-result-row__title">{item?.title || 'Sin título'}</div>
                    <div className="search-result-row__meta">
                        {item?.customer?.name || 'Sin cliente'}
                    </div>
                </div>
            </div>
        </button>
    );
};
